<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4" d="M7 2V13H10V22L17 10H13L17 2H7Z" fill="currentColor" />
    <path d="M17 10L7 13H10V22L17 10Z" fill="currentColor" />
  </svg>
</template>
